import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabaseClient'

export interface PublicPartner {
  name: string
  logo_url: string | null
  website_url: string | null
  color_code: string
}

/**
 * Hook pour récupérer les partenaires actifs via l'edge function public-partners.
 * Fallback sur requête directe Supabase si l'edge function n'est pas disponible.
 */
export function usePublicPartners() {
  const [partners, setPartners] = useState<PublicPartner[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    async function fetchPartners() {
      try {
        // Tentative via edge function
        const { data, error: fnError } = await supabase.functions.invoke('public-partners', {
          method: 'GET',
        })

        if (fnError) throw fnError

        if (!cancelled) {
          setPartners(data?.partners ?? [])
          setError(null)
        }
      } catch (err) {
        // Fallback : requête directe si RLS le permet
        try {
          const { data, error: dbError } = await supabase
            .from('partners')
            .select('name, logo_url, website_url, color_code')
            .eq('status', 'ACTIVE')
            .order('name')

          if (dbError) throw dbError

          if (!cancelled) {
            setPartners(data ?? [])
            setError(null)
          }
        } catch (fallbackErr) {
          if (!cancelled) {
            setError('Impossible de charger les partenaires')
            console.error('usePublicPartners error:', fallbackErr)
          }
        }
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    fetchPartners()
    return () => { cancelled = true }
  }, [])

  return { partners, loading, error }
}
